import { ETableStructureAlign, ETableStructureType, TTableStructure } from 'ui/EasTable/types';
import { TSmsListItem } from 'redux/reducers/sms/types';
import { EEmEnums } from 'redux/reducers/emManagement/constants';
import { DATES, DATES_ID } from '../../../../../services/constants/dates-constants';

export const tableStructure: TTableStructure<keyof TSmsListItem>[] = [
	{
		name: 'Sent at',
		selector: 'sentAt' as keyof TSmsListItem,
		show: true,
		sortable: true,
		filterable: true,
		colSpan: 1,
		type: ETableStructureType.DATE_TIME,
		align: ETableStructureAlign.LEFT,
		filter: [
			[DATES_ID.TODAY, DATES.TODAY],
			[DATES_ID.YESTERDAY, DATES.YESTERDAY],
			[DATES_ID.LAST_7_DAYS, DATES.LAST_7_DAYS],
			[DATES_ID.LAST_30_DAYS, DATES.LAST_30_DAYS],
			[DATES_ID.THIS_MONTH, DATES.THIS_MONTH],
			[DATES_ID.LAST_MONTH, DATES.LAST_MONTH],
			[DATES_ID.THIS_QUARTER, DATES.THIS_QUARTER],
			[DATES_ID.LAST_QUARTER, DATES.LAST_QUARTER],
			[DATES_ID.THIS_YEAR, DATES.THIS_YEAR],
			[DATES_ID.LAST_YEAR, DATES.LAST_YEAR],
			[DATES_ID.CUSTOM_RANGE, DATES.CUSTOM_RANGE],
		],
	},
	{
		name: 'Delivered at',
		selector: 'deliveredAt' as keyof TSmsListItem,
		show: false,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.DATE_TIME,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Failed at',
		selector: 'failedAt' as keyof TSmsListItem,
		show: false,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.DATE_TIME,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Created at',
		selector: 'createdAt' as keyof TSmsListItem,
		show: false,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.DATE_TIME,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Type',
		selector: 'typeHandle' as keyof TSmsListItem,
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.ARRAY_ID,
		align: ETableStructureAlign.LEFT,
		enumName: EEmEnums.SMS_TYPE,
	},
	{
		name: 'From',
		selector: 'fromPhoneNumber' as keyof TSmsListItem,
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Recipients',
		selector: 'recipients' as keyof TSmsListItem,
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STATUS_ARRAY,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Status',
		selector: 'status' as keyof TSmsListItem,
		show: true,
		sortable: true,
		filterable: true,
		colSpan: 1,
		type: ETableStructureType.STATUS,
		align: ETableStructureAlign.LEFT,
		filter: [
			['processing', 'Processing'],
			['created', 'Created'],
			['sent', 'Sent'],
			['delivered', 'Delivered'],
			['failed', 'Failed'],
		],
		colors: [
			['processing', 'primary.light'],
			['created', 'info.light'],
			['sent', 'info.light'],
			['delivered', 'success.light'],
			['failed', 'error.light'],
		],
	},
];
